export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1a1 1 0 00-2 0v12a1 1 0 001 1h13.324l-3 3.594a.856.856 0 00.11 1.207.86.86 0 001.21-.11l4.291-5.143a.856.856 0 000-1.097L12.643 7.31a.858.858 0 00-1.32 1.097l3 3.594H2V1z\" fill=\"#C9CBD4\"/>",
  "attrs": {
    "width": "18",
    "height": "19",
    "viewBox": "0 0 18 19",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};